module.exports = __webpack_public_path__ + "static/img/45713.7bbe325.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/45713.jpg
// module id = uv23
// module chunks = 1